<template>
	<h1>Modifier theme de question de fiche d'exercice</h1>
	<form @submit.prevent="submit" class="form-container">
		<div class="input-container">
			<label for="Difficulty"
				>Theme de question pour fiche d exercice</label
			>
			<input
				type="text"
				class="form-control"
				v-model="form.name"
				id="Name"
				placeholder="Name"
			/>
		</div>
		<p v-if="status !== ''" class="status">{{ status }}</p>
		<p class="errors">{{ errors }}</p>
		<input class="submit dark" type="submit" value="Valider" />
	</form>
</template>

<script>
import { authenticatedApiFetch } from '../../utils/utils'

export default {
	data() {
		return {
			form: {
				name: '',
			},
			errors: '',
		}
	},
	methods: {
		submit() {
			authenticatedApiFetch(`/exercise-question-themes/${this.$route.params.id}/`, { method: 'PUT', body: JSON.stringify(this.form) })
				.then(() => {
					this.$store.dispatch('getExerciseSheetThemes')
					this.$router.push({ name: 'SuperAdminAllExerciseSheetQuestionThemes' })
				})
				.catch((error) => {
					this.errors = error
				})
		},
		getQuestionTheme() {
			authenticatedApiFetch(`/exercise-question-themes/${this.$route.params.id}/`, { method: 'GET' })
				.then(res => res.json())
				.then(res => {
					this.form = res
				})
		},
	},
	created() {
		this.getQuestionTheme()
	},
}
</script>

<style>
</style>
